"use strict"

$ = jQuery

const rpp_snippets_sortable_parent = '#snippets-form'
const rpp_snippets_sortable_params = {
	axis: 'y',
	handle: '.title',
	items: '.rpp-admin-snippet'
}
const list_params_category = {
	ajax: {
		delay: 250,
		type: 'post',
		url: rpp_ajax.ajax_url,
		dataType: 'json',
		data: function(params) {
			return {
				term: params.term, // search term
				type: 'category',
				_ajax_nonce: rpp_ajax.nonce,
				action: 'revpress_list_options'
			};
		},
		processResults: function(data) {
			return {
				results: data
			}
		}
	}
}
const list_params_tag = {
	ajax: {
		delay: 250,
		type: 'post',
		url: rpp_ajax.ajax_url,
		dataType: 'json',
		data: function(params) {
			return {
				term: params.term, // search term
				type: 'tag',
				_ajax_nonce: rpp_ajax.nonce,
				action: 'revpress_list_options'
			};
		},
		processResults: function(data) {
			return {
				results: data
			}
		}
	}
}
const list_params_post = {
	ajax: {
		delay: 250,
		type: 'post',
		url: rpp_ajax.ajax_url,
		dataType: 'json',
		data: function(params) {
			return {
				term: params.term, // search term
				type: 'post_page',
				_ajax_nonce: rpp_ajax.nonce,
				action: 'revpress_list_options'
			};
		},
		processResults: function(data) {
			return {
				results: data
			}
		}
	}
}

function selectSourceSnippet(snippet_id) {
	$('#target-snippet-id').val(snippet_id)
	$('#code-source').val('')
	$('#import-box-wait').hide()
	$('#import-box-code').show()
}

function parseSourceSnippet() {
	let snippet_id = parseInt($('#target-snippet-id').val())
	let data = {
		_ajax_nonce: rpp_ajax.nonce,
		action: 'revpress_parse_code',
		code: encodeURI($('#code-source').val())
	}

	$('#import-box-code').hide()
	$('#import-box-wait').show()

	$.post(
		rpp_ajax.ajax_url,
		data,
		function(response) {
			if (response.success) {
				$('#snippet-' + snippet_id + '-params').val(response.params)
			}
			else {
				alert('Parsing the snippet code failed!')
			}

			tb_remove()
		}
	)
}

function showSnippetParams(snippet_id) {
	$('#params-box-info').hide()
	$('#params-box-wait').show()

	let data = {
		_ajax_nonce: rpp_ajax.nonce,
		action: 'revpress_show_params',
		params: $('#snippet-' + snippet_id + '-params').val()
	}

	$.post(
		rpp_ajax.ajax_url,
		data,
		function(response) {
			$('#params-box-wait').hide()
			$('#params-box-info').html(response.success ? response.html : '<p>Failed to render list of parameters</p>')
			$('#params-box-info').show()
		}
	)
}

function removeSnippet(snippet_id) {
	if (confirm('Are you sure you want to remove this snippet?')) {
		$('#snippet-remove-id').val(snippet_id)
		$('#snippet-remove-form').submit()
	}
}

/**
 * Autorun
 */
$(document).ready(function() {
	// Set header background
	$('#rpp-header').css('background', $('body').css('background'))

	// Relocate notifications
	$('#wpbody-content .notice').each(function(idx, elem) {
		let notice = $(elem).detach()

		$('#rpp-notices').append(notice)
	})

	// Listen to filter selection
	$('.rule-type').on('change', function() {
		let id = parseInt($(this).attr('data-id'))
		let value = $(this).val()

		if (value === 'category') {
			$('#snippet-' + id + '-rule-category-box').show()
			if (!$('#snippet-' + id + '-rule-category-list').hasClass('select2-hidden-accessible')) {
				$('#snippet-' + id + '-rule-category-list').select2(list_params_category)
			}
		}
		else {
			$('#snippet-' + id + '-rule-category-box').hide()
		}

		if (value === 'tag') {
			$('#snippet-' + id + '-rule-tag-box').show()
			if (!$('#snippet-' + id + '-rule-tag-list').hasClass('select2-hidden-accessible')) {
				$('#snippet-' + id + '-rule-tag-list').select2(list_params_tag)
			}
		}
		else {
			$('#snippet-' + id + '-rule-tag-box').hide()
		}

		if (value === 'post_page') {
			$('#snippet-' + id + '-rule-post-page-box').show()
			if (!$('#snippet-' + id + '-rule-post-page-list').hasClass('select2-hidden-accessible')) {
				$('#snippet-' + id + '-rule-post-page-list').select2(list_params_post)
			}
		}
		else {
			$('#snippet-' + id + '-rule-post-page-box').hide()
		}
	})

	// Show/hide user roles list when needed
	$('#exclude-roles').on('change', function() {
		if ($(this).prop('checked')) {
			$('#exclude-roles-box').show()
			if (!$('#exclude-role-list').hasClass('select2-hidden-accessible')) {
				$('#exclude-role-list').select2()
			}
		}
		else {
			$('#exclude-roles-box').hide()
		}
	})

	// Initiate visible dropdowns
	$('.select-box.active .rule-multi-select').each(function(idx, elem) {
		let list_type = $(elem).attr('data-list-type')

		switch (list_type) {
			case 'category':
				$(elem).select2(list_params_category)
				break

			case 'tag':
				$(elem).select2(list_params_tag)
				break

			case 'post_page':
				$(elem).select2(list_params_post)
				break

			default:
				$(elem).select2()
				break
		}
	})

	$('#priority-mode').on('change', function() {
		let on = $(this).prop('checked')

		if (on) {
			$('#exclude-roles-container').slideUp(180)
			$('.rpp-admin-snippet .priority').show()
			$('.snippet-body').slideUp(180, function() {
				$('.rpp-admin-snippet .title').addClass('drag')
				$(rpp_snippets_sortable_parent).sortable(rpp_snippets_sortable_params)
			})
		}
		else {
			$('.rpp-admin-snippet .title').removeClass('drag')
			$('.rpp-admin-snippet .priority').hide()
			$('.snippet-body').slideDown(180)
			$('#exclude-roles-container').slideDown(180, function() {
				$(rpp_snippets_sortable_parent).sortable('destroy')
			})
		}
	})

	// Save button in header
	$('#snippets-save-button').on('click', function() {
		// Get order of snippets
		if (!$(rpp_snippets_sortable_parent).hasClass('ui-sortable')) {
			$(rpp_snippets_sortable_parent).sortable(rpp_snippets_sortable_params)
		}
		$('#snippets-order').val($(rpp_snippets_sortable_parent).sortable('toArray', { attribute: 'data-id' }).join(','))

		// Submit the form
		$('#snippets-form').submit()
	})

// Style checkboxes and radio button
	set_yesno_checkers('yesno')

	// Initialize preview buttons
	$('.rpp-admin-snippet .action.preview').on('click', function() {
		let snippet_id = $(this).attr('data-id')
		let url = $(this).attr('href')

		let data = {
			_ajax_nonce: rpp_ajax.nonce,
			action: 'revpress_prepare_preview',
			params: $('#snippet-' + snippet_id + '-params').val()
		}

		$.post(
			rpp_ajax.ajax_url,
			data,
			function(response) {
				if (response.success) {
					new_window(url)
				}
				else {
					alert('Preparing the preview failed!')
				}
			}
		)

		return false
	})
})
